import FeedbackPage from '@app-studio-web/ui/pages/FeedbackPage'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function FeedbackAlmostTherePage() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    navigate('/sign-up/company')
  }

  return (
    <FeedbackPage
      emoji="✨"
      heading={t('pages.onboarding.feedbackAlmostThere.heading')}
      text={t('pages.onboarding.feedbackAlmostThere.text')}
      onSubmit={handleSubmit}
    />
  )
}
